import { memo } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import '../../global/typography.css';

function CannedFeedback(props) {
  const {
    list, selectedOptions, toggleListSelection, isCA,
  } = props;

  const lisItemStyle = (listId) => {
    const activeClass = isCA ? 'active-background-ca' : 'active-background';
    const inactiveClass = isCA ? 'inactive-background-ca' : 'inactive-background';
    const isSelected = selectedOptions?.includes(listId);
    return `roboto font-400 typography-regular can-item ${isSelected ? activeClass : inactiveClass}`;
  };

  return (
    <div className={isCA ? 'list-container-ca' : 'list-container'}>
      <div aria-label="canned-feedback" className="can-item-container">
        {list?.map((cannedFeedback) => (
          <button
            className={lisItemStyle(cannedFeedback.id)}
            data-testid={cannedFeedback.id}
            key={cannedFeedback.id}
            onClick={() => toggleListSelection(cannedFeedback.id)}
            type="button"
          >
            {cannedFeedback?.title}
          </button>
        ))}
      </div>
    </div>
  );
}

CannedFeedback.propTypes = {
  list: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
  })).isRequired,
  selectedOptions: PropTypes.arrayOf(PropTypes.string),
  toggleListSelection: PropTypes.func.isRequired,
  isCA: PropTypes.bool,
};

CannedFeedback.defaultProps = {
  selectedOptions: [],
  isCA: false,
};

export default memo(CannedFeedback);
